require('./productTemplateEditorHeader.i18n.json');
require('./productTemplateEditorHeader.tpl.html');
require('./productTemplateEditorHeaderController.js');

const ProductTemplateEditorHeaderComponent = {
    templateUrl: '/configuration/productTemplateEditor/header/productTemplateEditorHeader.tpl.html',
    controller: 'productTemplateEditorHeaderController',
    bindings: {
        productTemplateName:'<'
    }
};

angular.module('ums.configuration')
    .component('uiProductTemplateEditorHeader', ProductTemplateEditorHeaderComponent);
